import {
  TRANSACTION_LIST_SUCCESS,
  TRANSACTION_LIST_ERROR,
  TRANSACTION_CLEAR_ALL,
  SET_CONVERSATION_ACTIVE_STATUS,
} from '../constants/ActionTypes';

const initialState = {
  transactionList: null,
  isLoading: true,
  isError: false,
  isConversationActive: null,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case TRANSACTION_LIST_SUCCESS: {
      return {
        ...state,
        ...{ transactionList: action.payload || [], isLoading: false },
      };
    }

    case TRANSACTION_LIST_ERROR: {
      return {
        ...state,
        ...{ transactionList: [], isLoading: false, isError: true },
      };
    }

    case TRANSACTION_CLEAR_ALL: {
      return { ...state, ...{ transactionList: [] } };
    }

    case SET_CONVERSATION_ACTIVE_STATUS: {
      return { ...state, ...{ isConversationActive: action.payload } };
    }

    default:
      return state;
  }
};

export default Reducer;
